export function consoleLogVintage({ vintage }) {
  const vintageWine = vintage?.wine;
  /*eslint-disable no-console */
  console.log('vintage_id: ' + vintage.id);
  console.log('wine_id: ' + vintageWine?.id);
  console.log('winery_id: ' + vintageWine?.winery?.id);
  /*eslint-enable no-console */
}
